import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "font-bold"
}
const _hoisted_2 = { class: "flex flex-column justify-content-start align-items-start pl-0 list-none" }
const _hoisted_3 = { class: "pl-0 list-none" }

import { onBeforeMount, Ref, ref, toRefs } from 'vue';
import { useToast } from 'primevue/usetoast';
import { AssessmentMaterialData, AssessmentRecordFormData, DetailedEventInterface } from '@/types';
import { useTherapyStore } from '@/store';
import { can } from '@/composables';
import { PERMISSIONS } from '@/enum';

interface Props {
  event?: DetailedEventInterface;
  showAssessmentTitle?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EventEvaluationAssessmentsFiles',
  props: {
    event: {},
    showAssessmentTitle: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;
const { event, showAssessmentTitle } = toRefs(props);
const toast = useToast();
const therapyStore = useTherapyStore();
const evaluationAssessmentDownloading = ref<boolean>(false);
const evaluationAssessmentsRecordForms: Ref<AssessmentRecordFormData[] | undefined> = ref([]);

onBeforeMount(async () => await init());

const init = async () => {
  if (can([PERMISSIONS.THERAPY_EVENT_STORE_EVALUATION_SELECT_ASSESSMENT])) {
    await therapyStore.getEvaluationAssessments();
    await setEvaluationAssessmentsRecordForms();
  }
};

const setEvaluationAssessmentsRecordForms = async () => {
  if (evaluationAssessmentsRecordForms.value) {
    let materials = event.value?.event_type_data.assessment_record_form.assessment_materials;
    const materialItems = materials
      .sort((a, b) => +(b.deleted_at === null) - +(a.deleted_at === null))
      .filter((item) => materials.find((value) => value.title === item.title && item.deleted_at === null))
      .sort((a, b) => a.title.localeCompare(b.title));

    event.value.event_type_data.assessment_record_form.assessment_materials = materialItems;

    evaluationAssessmentsRecordForms.value.push(event.value?.event_type_data.assessment_record_form);
  }
};

const onClickAssessmentRecordForm = async (recordForm: AssessmentRecordFormData) => {
  evaluationAssessmentDownloading.value = true;
  await therapyStore
    .downloadEvaluationAssessmentsRecordForm(recordForm)
    .finally(async () => {
      evaluationAssessmentDownloading.value = false;
    })
    .catch((errorResponse) => {
      evaluationAssessmentDownloading.value = false;

      toast.add({
        severity: 'error',
        summary: 'Error',
        detail: errorResponse.data.message || errorResponse.statusText,
        life: 3000,
      });
    });
};

const onClickAssessmentMaterial = async (material: AssessmentMaterialData) => {
  evaluationAssessmentDownloading.value = true;
  await therapyStore
    .downloadEvaluationAssessmentsMaterial(material)
    .finally(async () => {
      evaluationAssessmentDownloading.value = false;
    })
    .catch((errorResponse) => {
      toast.add({
        severity: 'error',
        summary: 'Error',
        detail: errorResponse.data.message || errorResponse.statusText,
        life: 3000,
      });
    });
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(showAssessmentTitle))
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(evaluationAssessmentsRecordForms.value[0]?.assessment?.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(evaluationAssessmentsRecordForms.value, (form) => {
        return (_openBlock(), _createElementBlock("li", {
          key: form.id,
          class: "flex flex-column align-items-start"
        }, [
          _createVNode(_component_Button, {
            class: "p-button-link text-sm primary-color underline px-0 text-left",
            title: "Record Form",
            disabled: evaluationAssessmentDownloading.value,
            onClick: ($event: any) => (onClickAssessmentRecordForm(form))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Record Form " + _toDisplayString(form.title), 1)
            ]),
            _: 2
          }, 1032, ["disabled", "onClick"]),
          _createElementVNode("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.assessment_materials, (material) => {
              return (_openBlock(), _createElementBlock("li", {
                key: material.id,
                class: "flex align-items-start"
              }, [
                _createVNode(_component_Button, {
                  class: "p-button-link text-sm primary-color underline px-0 text-left",
                  title: "Material",
                  disabled: evaluationAssessmentDownloading.value,
                  onClick: ($event: any) => (onClickAssessmentMaterial(material))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(material.title), 1)
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"])
              ]))
            }), 128))
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})